import { STORAGE_KEYS } from "../constants/storage";

export const StorageService = {
  setItem: (key, value, persistent = false) => {
    const storage = persistent ? localStorage : sessionStorage;
    if (typeof value === 'object') {
        storage.setItem(key, JSON.stringify(value));
    }
    else {
        storage.setItem(key, value);
    }
  },

  getItem: (key) => {
    const value = localStorage.getItem(key) || sessionStorage.getItem(key);

    if (key === STORAGE_KEYS.ACCESS_TOKEN || key === STORAGE_KEYS.REFRESH_TOKEN) {
        return value;
    }
    
    try {
        return JSON.parse(value);
    } catch(e) {
        return value;
    }
  },

  removeItem: (key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  },

  clearAuthData: () => {
    StorageService.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    StorageService.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
  },

  saveRememberedID: (username) => {
    localStorage.setItem(STORAGE_KEYS.REMEMBERED_ID, username);
  },

  getRememberedID: () => {
    return localStorage.getItem(STORAGE_KEYS.REMEMBERED_ID) || "";
  },

  clearRememberedID: () => {
    localStorage.removeItem(STORAGE_KEYS.REMEMBERED_ID);
  },
};
